import { z } from "zod";

export const UpdateRolesSchema = z.object({
    name: z.string()
});

export type UpdateRolesFormData = z.infer<typeof UpdateRolesSchema>;